import React from "react";
import { twMerge } from "tailwind-merge";

interface FormFieldsetProps {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function FormFieldset({
  label,
  required = false,
  children,
  className = "",
}: FormFieldsetProps) {
  return (
    <fieldset className={twMerge("fieldset text-base", className)}>
      <legend className="fieldset-legend text-base font-bold gap-1">
        {label} {required && <span className="text-primary">REQUIRED</span>}
      </legend>
      {children}
    </fieldset>
  );
}

export default FormFieldset;
